import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Details extends React.PureComponent {

  static contextTypes = {
    admin: PropTypes.object
  }

  static propTypes = {
    formdata: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  state = {
    config: {}
  }

  formRef = React.createRef()

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { formdata } = this.props
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Next)', color: 'blue', handler: this._handleSubmit }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Title)', 
              name: 'title', 
              type: 'textfield', 
              required: true,
              defaultValue: formdata.title
            },
            { 
              label: 't(Logo)', 
              name: 'logo_id', 
              type: 'attachmentfield', 
              allow: { types: ['photos'] }, 
              multiple: false,
              defaultValue: formdata.logo_id
            },
            { 
              label: 't(Admins)', 
              name: 'admin_ids', 
              type: 'checkboxgroup', 
              endpoint: '/api/admin/team/users',
              valueKey: 'id', 
              textKey: 'full_name',
              filter: {
                is_active: {
                  $eq: true
                }
              },
              multiple: true, 
              required: true ,
              defaultValue: formdata.admin_ids,
              height: 268
            }
          ]
        }
      ]
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(agency) {
    this.props.onNext(agency)
  }

}

export default Details
